import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import VueToast from "vue-toast-notification";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "vue-toast-notification/dist/theme-sugar.css";
import "../public/assets/css/fonts.css";
import "../public/assets/css/style.css";

const app = createApp(App);
app.component("Toast", VueToast);

app.use(VueToast);
app.use(router); // Use the router
app.mount('#app');